import { Link } from "react-router-dom";
import Taskbar from '../components/Taskbar';
import SixLinksGrid from '../components/SixLinksGrid';
import InfoBar from '../components/InfoBar';
import MainImage from "../components/MainIImage";
import TwoColumnLayout from "../components/TwoColumnLayout";
import AppSidebar from "../components/AppSidebar";

const HomePage = () => {

  return (
    <>
     <Taskbar />
        <TwoColumnLayout sidebar={<AppSidebar />}>
      
      <div className="min-h-screen max-[942px]:pt-12 min-[942px]:mt-[51px] bg-bg text-text">

        <MainImage image="/images/vips/vip1.jpg"/>
      
        {/* Info Bar */}
          <InfoBar text="🎄✨ Merry Christmas 🎄✨ and a Victorious New Year in Advance! 🎄✨ May the light of Christ 🎄✨ guide you into a year filled with 🎄✨ wisdom, favor, and fulfillment. ✨🎄" />
        <div className="flex-grow">

          <SixLinksGrid />
        </div>

        {/* Footer */}
        <footer className="bg-accent shadow-inner text-text py-2">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <div className="mt-2">
              <Link to="/" className="hover:text-hover transition-colors duration-300">
                Privacy Policy
              </Link>{" "}
              |{" "}
              <Link to="/" className="hover:text-hover transition-colors duration-300">
                Terms of Service
              </Link>
            </div>
          </div>
        </footer>
      </div>
    </TwoColumnLayout>
    </>
  );
};

export default HomePage;
